/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePopupConfigReqVo
 */
export interface UpdatePopupConfigReqVo {
    /**
     * 横坐标
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    xCoordinate: number;
    /**
     * 纵坐标
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    yCoordinate: number;
    /**
     * 标题
     * @type {string}
     * @memberof UpdatePopupConfigReqVo
     */
    title: string;
    /**
     * 内容（韩文）
     * @type {string}
     * @memberof UpdatePopupConfigReqVo
     */
    content: string;
    /**
     * 内容（中文）
     * @type {string}
     * @memberof UpdatePopupConfigReqVo
     */
    contentCn: string;
    /**
     * 开始日期
     * @type {string}
     * @memberof UpdatePopupConfigReqVo
     */
    beginDate: string;
    /**
     * 结束日期
     * @type {string}
     * @memberof UpdatePopupConfigReqVo
     */
    endDate: string;
    /**
     * 宽度
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    width?: number;
    /**
     * 高度
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    height?: number;
    /**
     * 是否居中：0-不居中，1-居中
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    center?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    enable: number;
    /**
     * 链接地址
     * @type {string}
     * @memberof UpdatePopupConfigReqVo
     */
    url?: string;
    /**
     * 是否显示：0-不显示，1-显示
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    show: number;
    /**
     * 是否当前窗口打开：0-不在当前窗口，1-在当前窗口
     * @type {number}
     * @memberof UpdatePopupConfigReqVo
     */
    selfWindow: number;
}

/**
 * Check if a given object implements the UpdatePopupConfigReqVo interface.
 */
export function instanceOfUpdatePopupConfigReqVo(value: object): value is UpdatePopupConfigReqVo {
    if (!('xCoordinate' in value) || value['xCoordinate'] === undefined) return false;
    if (!('yCoordinate' in value) || value['yCoordinate'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('contentCn' in value) || value['contentCn'] === undefined) return false;
    if (!('beginDate' in value) || value['beginDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('show' in value) || value['show'] === undefined) return false;
    if (!('selfWindow' in value) || value['selfWindow'] === undefined) return false;
    return true;
}

export function UpdatePopupConfigReqVoFromJSON(json: any): UpdatePopupConfigReqVo {
    return UpdatePopupConfigReqVoFromJSONTyped(json, false);
}

export function UpdatePopupConfigReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePopupConfigReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'xCoordinate': json['xCoordinate'],
        'yCoordinate': json['yCoordinate'],
        'title': json['title'],
        'content': json['content'],
        'contentCn': json['contentCn'],
        'beginDate': json['beginDate'],
        'endDate': json['endDate'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'center': json['center'] == null ? undefined : json['center'],
        'enable': json['enable'],
        'url': json['url'] == null ? undefined : json['url'],
        'show': json['show'],
        'selfWindow': json['selfWindow'],
    };
}

export function UpdatePopupConfigReqVoToJSON(json: any): UpdatePopupConfigReqVo {
    return UpdatePopupConfigReqVoToJSONTyped(json, false);
}

export function UpdatePopupConfigReqVoToJSONTyped(value?: UpdatePopupConfigReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'xCoordinate': value['xCoordinate'],
        'yCoordinate': value['yCoordinate'],
        'title': value['title'],
        'content': value['content'],
        'contentCn': value['contentCn'],
        'beginDate': value['beginDate'],
        'endDate': value['endDate'],
        'width': value['width'],
        'height': value['height'],
        'center': value['center'],
        'enable': value['enable'],
        'url': value['url'],
        'show': value['show'],
        'selfWindow': value['selfWindow'],
    };
}

